/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Invoice_Misa_Template_NumberInputs */

const vi_invoice_misa_template_number = /** @type {(inputs: Invoice_Misa_Template_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mẫu số ${i?.number}`)
};

/**

* @param {Invoice_Misa_Template_NumberInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_misa_template_number = /** @type {((inputs: Invoice_Misa_Template_NumberInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Misa_Template_NumberInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_misa_template_number(inputs)
});